import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  savedMessagesKey,
  errorMessage,
} from '@features/savedMessages';
import axiosInstance from '@server/axiosInstance';
import { tampleteSavedMessagesRoute } from '../api/constants';

type useUpdateTemplateSavedMessageProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateTemplateSavedMessage = ({
  setErrorText = () => { },
}: useUpdateTemplateSavedMessageProps) => {
  const client = useQueryClient();

  const { mutate: updateSavedMessage, isLoading: isUpdatingSavedMessage } =
    useMutation({
      mutationFn: (variables: {
        saved_message_id: number;
        label: string;
        content: string;
        etemplate_id: number
      }) =>
        axiosInstance
          .put(tampleteSavedMessagesRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([savedMessagesKey]);
        }
      },
      onError: (error: { message?: string }) => {
        setErrorText(error?.message || errorMessage);
      },
    });

  return {
    updateSavedMessage,
    isUpdatingSavedMessage,
  };
};
